import { DashboardModule, Form } from '@domain-group/suit-theme'

import type { UseFormPayload } from '@domain-group/react-hooks'

interface PortalDetailsProps {
  portalFormPayload: UseFormPayload,
}

const PortalDetails = (props: PortalDetailsProps) => {
  const { portalFormPayload } = props

  const {
    entityState: {
      password,
      short_code,
      title,
      username,
    },
    errors,
    handlers,
  } = portalFormPayload

  return (
    <DashboardModule title="Portal Details">
      <Form padding="large">
        <Form.Row>
          <Form.Field label="* Title" errorMessage={errors.title}>
            <input type="text" name="title" value={title} {...handlers} />
          </Form.Field>

          {/*
           // @ts-expect-error TS2339 */}
          <Form.Field label="* Short Code" errorMessage={errors.short_code} marginTop={['large', 0]}>
            <input type="text" name="short_code" value={short_code} {...handlers} />
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field label="Username">
            <input type="text" name="username" value={username} {...handlers} />
          </Form.Field>

          {/*
           // @ts-expect-error TS2322 */}
          <Form.Field label="Password" marginTop={['large', 0]}>
            <input type="text" name="password" value={password} {...handlers} />
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

export default PortalDetails
